export const titles = ['', 'Mr.', 'Mrs.', 'Ms.']

export const DEFAULT_LANGUAGE = 'en'

export const DEFAULT_LOCALE = 'en-gb'

export const CYPRESS_TEST_FLAG = 'CYPRESS_TEST'

export const isStringFormat = 'YYYY-MM-DDTHH:mm:ss.sssZ'

export const LANGUAGE_ORDER_PREFERNCE = {
  en: 6,
  de: 5,
  pt: 4,
  es: 3,
  fr: 3,
  it: 1,
}

const isIE = () => {
  const ua = (navigator || window.navigator).userAgent
  return ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1
}

export const BROWSER_IE = isIE()

export const REFUND_POLICIES = {
  NOT_REFUNDABLE: 'notRefundable',
  PARTIALLY_REFUNDABLE: 'partiallyRefundable',
  FULLY_REFUNDABLE: 'fullyRefundable',
  EXCHANGE_FOR_VOUCHER: 'exchangableForVoucher',
}

export const AMENDABLE_POLICIES = {
  NOT_AMENDABLE: 'notAmendable',
  AMENDABLE: 'amendable',
  PARTLY_AMENDABLE: 'partlyAmendable',
  UNKNOWN: 'unknown',
}

export const MODE_IDS = {
  train: 'train',
  bus: 'bus',
  plane: 'plane',
  ferry: 'ferry',
  airport_transfer: 'airport-transfer',
}
